import { useEffect, useState } from "react";
import axios from "axios";
import { BroadcastCard } from "@/components/BroadcastCard";
import { CheckoutNudgeCard } from "@/components/CheckoutNudgeCard";
import { GraceTestCard } from "@/components/admin/emails/GraceTestCard";
import { RetryStrip } from "@/components/admin/emails/RetryStrip";
import { EmailKindFilters } from "@/components/admin/emails/EmailKindFilters";
import { EmailLogTable } from "@/components/admin/emails/EmailLogTable";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminEmailsPanel = () => {
  const [data, setData] = useState(null);
  const [kind, setKind] = useState("");
  const [loading, setLoading] = useState(true);
  const [tick, setTick] = useState(0);
  const refresh = () => setTick((t) => t + 1);

  useEffect(() => {
    setLoading(true);
    axios.get(`${API}/admin/emails`, { params: kind ? { kind } : {} })
      .then((r) => setData(r.data))
      .catch(() => setData({ emails: [], counts: {} }))
      .finally(() => setLoading(false));
  }, [kind, tick]);

  return (
    <div className="space-y-6" data-testid="admin-emails-panel">
      <BroadcastCard
        endpoint="rich-welcome"
        tag="Rich's welcome letter"
        title="Welcome to the family home."
        description="Sent automatically the moment a new member confirms their email. This button covers the members who joined before it existed — each gets it once, ever."
        testIdPrefix="rich-welcome"
        tone="green"
        onSent={refresh}
      />
      <BroadcastCard
        endpoint="launch-email"
        tag="Launch announcement"
        title={'"We\'re live — here\'s your door."'}
        description="One email to every confirmed member, pointing at their next unfinished module. Each member gets it once — ever."
        testIdPrefix="launch-email"
        onSent={refresh}
      />
      <GraceTestCard onSent={refresh} />
      <CheckoutNudgeCard onSent={refresh} />
      <RetryStrip queue={data?.retry_queue || 0} onDone={refresh} />
      <EmailKindFilters counts={data?.counts || {}} kind={kind} onChange={setKind} />
      <EmailLogTable emails={data?.emails || []} loading={loading} />
    </div>
  );
};
